import Vue from "vue";
import axios from "axios";
import { store } from "Store/store";
//import VueNotifications from 'vue-notifications';
import router from "Router";
import AppConfig from "Constants/AppConfig";

const api = axios.create({
    baseURL: AppConfig.baseApiUrl,
    timeout: 25000, // 25 seconds timeout
});

api.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
api.defaults.headers.common["X-API-KEY"] = "1234567890123456789012345678901234567890";

if ($cookies.get("token") !== "undefined" && $cookies.get("token") !== null) {
    const token = $cookies.get("token").token;

    if (typeof $cookies.get("token") !== "undefined" && $cookies.get("token") !== null) {
        api.defaults.headers.common["Authorization"] = "Bearer " + token;
    }
}

function decode_utf8(s) {
    return decodeURIComponent(escape(s));
}

//api.defaults.headers.common['Authorization'] = 'Basic amFzb24ubWF5QGJsYWNrY2FydmVyLmNvbTpCbGl6emFyMg==';
// api.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
api.defaults.headers.post["Content-Type"] = "application/json";
//api.defaults.headers.post['Content-Type'] = 'multipart/form-data';
/*api.defaults.headers.get[''] = '';
api.defaults.headers.post[''] = '';
api.defaults.headers.put[''] = '';
api.defaults.headers.patch[''] = '';
api.defaults.headers.delete[''] = '';*/

// Add a request interceptor
/* global window axios */
/*api.interceptors.request.use(function (config) {
    /* global window Store * /
    let token = Store.get('jwt.token')
    let location = Store.get('location')

    if (token) {
      config.headers.common['Authorization'] = 'Bearer ' + token
    }
    // Append location id for every post/get request
    if (location) {
      if (config.data) {
        config.data.location_id = location.id
      }
      else if (config.params) {
        config.params.location_id = location.id
      }
    }

    return config
  }, function (error) {
    // Do something with request error
    return Promise.reject(error)
  })*/

api.interceptors.response.use(
    (response) => {
        if (typeof response.data.code !== "undefined" && typeof response.data.message !== "undefined" && response.data.message) {
            Vue.notify({
                group: "loggedIn",
                type: response.data.type,
                text: decode_utf8(response.data.message),
                duration: response.data.duration ? +response.data.duration : 4000,
            });
        }
        return response;
    },
    (error) => {
        //Quasar Toast Schema
        let message = {
            html: null,
            icon: "fa-warning",
            timeout: 8000,
        };

        if (
            typeof error !== "undefined" &&
            typeof error.response !== "undefined" &&
            typeof error.response.data !== "undefined" &&
            typeof error.response.status !== "undefined"
        ) {
            if (
                typeof error.response.data !== "undefined" &&
                error.response.data != "undefined" &&
                typeof error.response.data.message !== "undefined" &&
                error.response.data.message != false
            ) {
                // uncaught if error.response.data undefined
                message.html = decode_utf8(error.response.data.message);
            } else if (typeof error.response.data.message !== "undefined" && error.response.data.message == false) {
                message.html = null;
            } else {
                //Setup Generic Response Messages
                if (error.response.status === 400) {
                    message.html = "Bad request";
                } else if (error.response.status === 401) {
                    message.html = "Invalid login credentials.";
                } else if (error.response.status === 403) {
                    message.html = "Invalid login credentials.";
                } else if (error.response.status === 404) {
                    message.html = "Oops! Record not found.";
                } else if (error.response.status === 405) {
                    message.html = "Oops! Permission denied.";
                } else if (error.response.status === 422) {
                    //Validation Message
                } else if (error.response.status >= 500) {
                    message.html = "Server Error";
                }
            }
            // if 401 or 403 status then log user out and send to login
            if (error.response.status === 401 || error.response.status === 403) {
                if (
                    !(router && router.currentRoute && router.currentRoute.params && router.currentRoute.params.redirect) &&
                    localStorage.getItem("user") !== null
                ) {
                    // if user still logged in
                    store.commit("logoutUser", { redirect: router.currentRoute.fullPath, locale: store.getters.selectedLocale.locale, returnToLogin: true });
                } else {
                    store.commit("logoutUser", { returnToLogin: true });
                }
            }

            //Try to Use the Response Message
            if (error.hasOwnProperty("response") && error.response.hasOwnProperty("error")) {
                if (error.response.data.hasOwnProperty("message") && error.response.data.error.length > 0) {
                    message.html = decode_utf8(error.response.data.error);
                }
            }
        }

        if (error && error.response && error.response.status !== 403 && message.html != null) {
            // VueNotifications.error({ message: message.html });
            setTimeout(function () {
                Vue.notify({
                    group: "loggedIn",
                    type: "error",
                    text: decode_utf8(message.html),
                });
            }, 500);
        }
    }
);

export default api;
